/**
 * EM/Lead Portal Layout — wraps all EM portal pages with nav sidebar.
 * Uses KPMG Dark Pink (#C6007E) accent.
 */
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import PortalNav, { DRAWER_WIDTH, DRAWER_COLLAPSED_WIDTH } from '../shared/PortalNav';

const EMLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const sidebarWidth = collapsed ? DRAWER_COLLAPSED_WIDTH : DRAWER_WIDTH;

  return (
    <Box sx={{ display: 'flex' }}>
      <PortalNav portal="em" collapsed={collapsed} onToggleCollapse={() => setCollapsed((c) => !c)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${sidebarWidth}px)` },
          transition: 'width 0.2s ease',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, rgba(198,0,126,0.05) 0%, rgba(72,54,152,0.04) 35%, rgba(0,51,141,0.03) 65%, rgba(198,0,126,0.03) 100%)',
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default EMLayout;
